import { __awaiter } from "tslib";
import { useSound } from '@/logics/sound';
import ApiManager from '@/managers/apimanagers';
import { useStore } from '@/store/store';
import { ref } from 'vue';
import MyPusher from './pusher';
export const MAX_LENGTH_HISTORY = 100;
/**
 * @summary 歩み値の変化によって色付けを行う
 * @param histories 歩み値の配列
 */
const build = (histories) => {
    return histories.map((current, index) => {
        const before = histories[index + 1];
        current.trade = getType(before, current);
        return current;
    });
};
const getType = (before, current) => {
    if (!before || Number(current.price) === Number(before.price)) {
        return '';
    }
    return Number(current.price) > Number(before.price) ? 'buy' : 'sell';
};
/**
 * @summary 歩み値情報取得
 */
export const useHistory = () => {
    const store = useStore();
    /**
     * @returns 板情報のリスト
     */
    const getHistory = () => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/history?pair=${store.state.symbol.pair}&limit=${MAX_LENGTH_HISTORY}`;
        const histories = yield ApiManager.get(url).catch((err) => {
            return Promise.reject(err);
        });
        return build(histories);
    });
    const getLatestValue = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const url = `/history?pair=${store.state.symbol.pair}&limit=1`;
        const histories = yield ApiManager.get(url).catch((err) => {
            return Promise.reject(err);
        });
        store.commit('setLatestValue', {
            price: Number((_a = histories[0]) === null || _a === void 0 ? void 0 : _a.price) || 0,
            amount: Number((_b = histories[0]) === null || _b === void 0 ? void 0 : _b.amount) || 0,
        });
        return Number((_c = histories[0]) === null || _c === void 0 ? void 0 : _c.price) || 0;
    });
    return { getHistory, getLatestValue };
};
/**
 * @summary 歩み値情報の購読
 */
export const historySubscriber = (initList = []) => {
    const list = ref(initList);
    let channel;
    const store = useStore();
    const { moveContract, play } = useSound();
    const subscribe = () => {
        channel = MyPusher.subscribe('trade-feed-table');
        const pair = store.getters.symbol.pair;
        channel.bind(`trade-feed-table-${pair.toLowerCase()}`, flush);
    };
    const unsubscribe = () => {
        channel === null || channel === void 0 ? void 0 : channel.unbind();
        channel === null || channel === void 0 ? void 0 : channel.unsubscribe();
    };
    let stockHistories = [];
    const flush = (stockHistory) => {
        // 0.3秒に一回だけ画面描画させる（フロント負荷軽減のため）
        if (stockHistories.length === 0) {
            setTimeout(() => {
                bind(stockHistories);
                stockHistories = [];
            }, 300);
        }
        stockHistories.push(stockHistory);
    };
    const bind = (data) => {
        const latestData = data[data.length - 1];
        // 最新の約定値更新
        store.commit('setLatestValue', { price: Number(latestData.price), amount: Number(latestData.amount) });
        play(moveContract);
        const insertData = data.reverse().map((d) => {
            return {
                price: d.price,
                amount: d.amount,
                time: d.time,
                trade: getType(list.value[0], d),
                animation: list.value[0] && list.value[0].animation === 'ok0' ? 'ok1' : 'ok0',
            };
        });
        list.value = [
            ...insertData,
            ...list.value.map((l) => {
                l.animation = '';
                return l;
            }),
        ].filter((_, index) => index < MAX_LENGTH_HISTORY);
    };
    return { subscribe, unsubscribe, bind, list };
};
